import { render, staticRenderFns } from "./DefectReport.vue?vue&type=template&id=5d1b0146&scoped=true&"
import script from "./DefectReport.vue?vue&type=script&lang=js&"
export * from "./DefectReport.vue?vue&type=script&lang=js&"
import style0 from "./DefectReport.vue?vue&type=style&index=0&id=5d1b0146&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d1b0146",
  null
  
)

export default component.exports